import { render, staticRenderFns } from "./PorletBuscadorCuadroMando.vue?vue&type=template&id=66ae69da&"
import script from "./PorletBuscadorCuadroMando.vue?vue&type=script&lang=js&"
export * from "./PorletBuscadorCuadroMando.vue?vue&type=script&lang=js&"
import style0 from "./PorletBuscadorCuadroMando.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports